<template>
  <div style="height: 100%">
    <div class="pc-body">
      <div class="body">
        <div class="content-header">
          <img class="content-header-img" :src='"static/pic/" + this.config.home.pcHeaderImage' />
        </div>
        <div class="menu">
          <div class="menu-inner">
            <span
              v-for="(item, index) in menu.navs"
              class="nav-name"
              :key="item"
              @click="handleRouter(index)"
              >{{ item }}</span>
          </div>
        </div>
        <div class="router"><router-view></router-view></div>
        <div class="copyright">
          Kehui Wu Group Dec.2012, All rights reserved
        </div>
      </div>
    </div>
    <div class="main-mobile-body">
      <div class="main-body">
        <div class="menu1">
          <div class="header2">
            <div class="menu-title">{{ menu.title }}</div>
            <img
              src="../assets/img/menu-mobile.png"
              @click="isShowMobileMenu = !isShowMobileMenu"
            />
          </div>
          <div class="nav" v-show="isShowMobileMenu">
            <span
                v-for="(item, index) in menu.navs"
                class="nav-name"
                :key="item"
                @click="handleRouter(index)"
                >{{ item }}</span>
          </div>
        </div>
        <div class="content-header">
          <img class="content-header-img" :src='"static/pic/" + this.config.home.mobileHeaderImage' />
        </div>
        <div class="router">
          <router-view></router-view>
        </div>
        <div class="copyright">
          Kehui Wu Group Dec.2012, All rights reserved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {loadCachedLanStatus,getCurLan,changeLan,isChinese} from '@/util/tools'
import axios from 'axios'

export default {
  name: "main-page",
  data() {
    return {
      config: {
        home: {
            pcHeaderImage: "home/header-img.jpg",
            mobileHeaderImage: 'home/header-img_m.jpg'
        }
      },
      menu: {
        title: "表面物理国家重点实验室SF09组\r\n中国科学院物理研究所",
        navs: [
          "首页",
          "小组成员",
          "研究方向",
          "发表论文",
          "新闻及进展",
          "仪器设备",
          "小组相册",
          "关于我们",
          "English"
        ]
      },
      isShowMobileMenu: false,
    }
  },
  mounted() {
    loadCachedLanStatus();
    this.updateMenu();
    this.$router.push({ name: "home-page" });
  },
  methods: {
    updateMenu() {
      var lan = isChinese() ?  "English" : "中文";
      var self = this
      getCurLan().then(res => {
        self.config = res
        self.menu.navs = [
          self.config.home.title,
          self.config.members.title,
          self.config.research.title,
          self.config.publication.title,
          self.config.news.title,
          self.config.equipment.title,
          self.config.photos.title,
          self.config.about.title,
          lan
        ]
      })
      
    },
    handleRouter(pageName) {
      if (this.isShowMobileMenu) {
        this.isShowMobileMenu = false
      }
      switch (pageName) {
        case 0:
          this.$router.push({ name: "home-page" });
          return;
        case 1:
          this.$router.push({ name: "members-page" });
          return;
        case 2:
          this.$router.push({ name: "research-page" });
          return;
        case 3:
          this.$router.push({ name: "publication-page" });
          return;
        case 4:
          this.$router.push({ name: "news-page" });
          return;
        case 5:
          this.$router.push({ name: "equipment-page" });
          return;
        case 6:
          this.$router.push({ name: "photos-page" });
          return;
        // case 7:
        //   this.$router.push({ name: "contact-page" });
        //   return;
        case 7:
          this.$router.push({ name: "about-page" });
          return;
        case 8:
          changeLan();
          this.updateMenu();
          // this.$router.go(0);
          window.location.reload()
          return;
      }
    }
  }
};
</script>
<style lang="scss" src="../assets/styles/pc/main-page.scss"></style>
<style lang="scss" src="../assets/styles/mobile/main-page.scss"></style>



// WEBPACK FOOTER //
// src/components/Main.vue